import moment, { Moment } from "moment";
import "moment/locale/nb";
import { Days, OpeningHours } from "../../../../../../models/state";

const INDEX_TO_DAY = {
    0: "Man",
    1: "Tir",
    2: "Ons",
    3: "Tor",
    4: "Fre",
    5: "Lør",
    6: "Søn",
} as const;

const DAY_TO_INDEX = {
    Man: 0,
    Tir: 1,
    Ons: 2,
    Tor: 3,
    Fre: 4,
    Lør: 5,
    Søn: 6,
} as const;

export const getWeekdayIndex = () => {
    const today = moment();
    today.locale("nb");
    return today.weekday() as keyof typeof INDEX_TO_DAY;
};

export const findOpeningTimeForDay = (open: OpeningHours[], weekdayIndex: keyof typeof INDEX_TO_DAY) =>
    open.find((item) => {
        const isSameDay = item.days === INDEX_TO_DAY[weekdayIndex];
        const [start, end] = item.days.split("-").map((day) => DAY_TO_INDEX[day.trim() as Days]);
        return isSameDay || (weekdayIndex >= start && weekdayIndex <= end);
    });

export const isShopOpen = (openingHours: string | undefined, now: Moment): boolean => {
    if (!openingHours) return false;
    const [open, close] = openingHours.split("-");
    const openingHoursStartTime = moment({ hour: parseInt(open.substr(0, 2)) });
    const openingHoursCloseTime = moment({ hour: parseInt(close.substr(0, 2)) });
    return now.isBetween(openingHoursStartTime, openingHoursCloseTime);
};
